<template>
  <div>

    <section id="content">
      <div class="content-wrap">
        <div class="container clearfix">
          <div class="row">
            <div class="col-sm-12" id="app">
              <div>
                <div class v-show="!carregando">
                  <div class="table-responsive" data-auto>
                    <div id="mensagem"></div>
                    <div id="errors" v-if="errors.length > 0">
                      <div class="style-msg2 errormsg">
                        <div class="msgtitle">Corrigir o(s) seguinte(s) erro(s):</div>
                        <div class="sb-msg">
                          <ul>
                            <li :key="index" v-for="(error,index) in errors">{{error}}</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <vs-table :striped="true" search max-items="15" pagination :data="content">
                    <template slot="header" class="header-vstable">
                      <div class="area-header">
                        <h3>Marcas</h3>
                      </div>
                    </template>
                    <template slot="thead">
                      <vs-th style="width:45px;" class="text-center">                        
                        <router-link to="/paineldegerenciamento/listamarcas/novo" class="text-center">
                          <i
                            class="icon-line-circle-plus i-circled i-small"
                            style="background-color:#9ACD32"
                          ></i>
                        </router-link></vs-th>
                      <vs-th style="text-align:center;"  class="text-center" :style="'width:'+iconArea+'px'">Ações</vs-th>
                      <vs-th sort-key="titulo">Título</vs-th>
                      <vs-th sort-key="tsInclusao" style="width:150px;" class="text-center">
                        <i class="icon-calendar"></i>
                      </vs-th>
                      <vs-th sort-key="ativo" style="width:45px;">Ativo</vs-th>
                      <vs-th sort-key="marcaId" style="width:45px;">ID</vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="indextr"  class="text-center" >{{indextr + 1}}</vs-td>
                        <vs-td  class="text-center acoes">
                          <a
                            class="icone-editar"
                            data-editar
                            @click="fnEdita('/paineldegerenciamento/listamarcas/'+data[indextr].marcaId+'/editar')"
                          >
                            <i class="i-circled i-small i-light icon-line-edit"></i>
                          </a>
                          <a
                            class="icone-editar"
                            data-editar
                            @click="fnEdita('/paineldegerenciamento/listamarcas/'+data[indextr].marcaId+'/modelos')"
                          >
                            <i class="i-circled i-small i-light icon-car-alt"></i>
                          </a>
                        </vs-td>
                        <vs-td :data="data[indextr].titulo">{{data[indextr].titulo}}</vs-td>
                        <vs-td  class="text-center" :data="data[indextr].tsInclusao">{{formatData(data[indextr].tsInclusao)}}</vs-td>
                        <vs-td :data="data[indextr].ativo" class="text-center text-icon">
                          <i  @click="fnAtiva(data[indextr].marcaId,data[indextr].titulo,data[indextr].ativo)"
                            class="i-rounded i-small icon-check i-small-xs"
                            :style="data[indextr].ativo ? 'background-color:#2ecc71': 'background-color:#D3D3D3'"
                          ></i>
                        </vs-td>
                        <vs-td :data="data[indextr].marcaId">{{data[indextr].marcaId}}</vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- #content end -->
  </div>
</template>

<script>
import { deleteData, getData } from "../../../global/utils";

export default {
  
  data: function () {
    return {
      stripe: true,
      colorAlert: "primary",
      titleAlert: '',
      activeAlert: false,
      content: [],
      iconArea: 50 * 2,
      errors: [],
      erro: "",
      urlApi: "listamarcas/",
      carregando: true,
      deleteId: "",
      deleteAtivo: null,
      deleteTitulo: "",
    };
  },
  mounted() {
    this.fnCarregaItems();
  },
  methods: {
    async fnCarregaItems() {
      let data = await getData(this.urlApi);
      this.content = data[0].content;
      this.carregando = false;
      this.$vs.loading.close();
    },
    fnAdd() {
      this.$router.push({path: "/paineldegerenciamento/listamarcas/novo"})
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY HH:MM");
    },
    fnAtiva(valueId, valueTitle, valueAtivo) {
      this.deleteId = valueId;
      this.deleteTitulo = valueTitle;
      this.deleteAtivo = valueAtivo
      this.$vs.dialog({
        color: this.colorAlert,
        acceptText: 'Continuar',
        title: this.deleteAtivo ? "Deseja inativar o item " + valueTitle + "?" : "Deseja ativar o item "  + valueTitle + "?",
        text: this.deleteAtivo ? "O item não será exibido em algumas aplicações" : "O item será exibido normalmente nas aplicações",
        accept: this.fn_delete,
      });
    },
    async fn_delete() {
      await deleteData(this.urlApi+"ativa/", this.deleteId, "marcaId" ,this.deleteAtivo );
      this.fnCarregaItems();
      this.deleteAtivo = null
    },
    fnEdita(valueUrl){
        this.$router.push({path: valueUrl})
    }
  },

};
</script>

<style lang="less" scoped>
#page-menu-wrap {
  position: relative !important;
}
.vs-table-text {
  text-align: center;
}

.text-icon {
  span {
    display: block !important;
    text-align: center !important;
  }
  .i-small-xs {
    font-size: 10px !important;
    margin: 0 !important;
    height: 16px !important;
    width: 16px !important;
    line-height: 16px !important;
    float: none !important;
  }
}
.header-table {
  padding: 15px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}

</style>